/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VmcPoolOrgRequestStateEnum = 'RECEIVED' | 'IN_PROGRESS' | 'PENDING_APPROVAL' | 'DENIED_APPROVAL' | 'DONE' | 'FAILED';

export const VmcPoolOrgRequestStateEnum = {

    RECEIVED: 'RECEIVED' as VmcPoolOrgRequestStateEnum,

    IN_PROGRESS: 'IN_PROGRESS' as VmcPoolOrgRequestStateEnum,

    PENDING_APPROVAL: 'PENDING_APPROVAL' as VmcPoolOrgRequestStateEnum,

    DENIED_APPROVAL: 'DENIED_APPROVAL' as VmcPoolOrgRequestStateEnum,

    DONE: 'DONE' as VmcPoolOrgRequestStateEnum,

    FAILED: 'FAILED' as VmcPoolOrgRequestStateEnum
};

